import {createApp} from '@/main'
/**
 * @description 退出登录
 * @param {Object} time context
 */
export function logout(number) {
    createApp().app.$message.warning(`审核配置有更新，${number}秒后即将重新登录！`)
    // this.$message.warning('审核配置有更新，3秒后即将重新登录！')
    localStorage.removeItem("loginInfo");
    localStorage.removeItem("isAuditEnabled");
    localStorage.removeItem("isPointsEnable");
    localStorage.removeItem("powers");
    sessionStorage.removeItem("roleCode");
    localStorage.removeItem("createUid");
    localStorage.removeItem("token");
    localStorage.removeItem("firstPage");
    sessionStorage.removeItem("picLove");
    sessionStorage.removeItem("isChangePsw");
    setTimeout(() => {
        // location.reload();
        createApp().app.$router.push("/loginNoToken");
    }, 3000);
}